import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideServiceWorker } from '@angular/service-worker';
import { createClient } from '@supabase/supabase-js';
import { routes } from './app.routes';
import { SUPABASE_CLIENT } from './core/api/supabase-client.token';
import { Database } from './core/types/database.types';
import { environment } from '../environments/environments';

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes),
        provideServiceWorker('ngsw-worker.js', {
            enabled: true,
            registrationStrategy: 'registerWhenStable:30000',
        }),
        {
            provide: SUPABASE_CLIENT,
            useFactory: () =>
                createClient<Database>(
                    environment.supabaseUrl,
                    environment.supabaseKey,
                ),
        },
    ],
};
